export const tags = [
    'FrameReferenceTime',
    'ActualFrameDuration',
];
